<template>
  <div class="container-fluid px-4 mt-4">
    <!-- Loading ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p>Yükleniyor...</p>
    </div>

    <div class="row" v-show="!loading">
      <div class="container-fluid px-3">
        <vue-good-table
            mode="remote"
            @on-page-change="onPageChange"
            :rows="rows"
            :columns="columns"
            :totalRows="totalRecords"
            :line-numbers="true"
            :pagination-options="{
              enabled: true,
              perPage: perPage,
              perPageDropdown: [perPage],
              dropdownAllowAll: false,
              mode: 'records',
              nextLabel: 'Sonraki',
              prevLabel: 'Önceki',
              rowsPerPageLabel: 'Sayfa başına satır',
              ofLabel: '/',
              pageLabel: 'sayfa',
              allLabel: 'Tümü',
              setCurrentPage: currentPage
            }"
        >
          <template #table-row="props">
            <span v-if="props.column.field === 'actions'" class="d-flex flex-wrap gap-2">
              <b-button
                size="sm"
                variant="primary"
                :disabled="downloadingId === props.row.id"
                @click="downloadPdf(props.row)"
              >
                <b-spinner v-if="downloadingId === props.row.id" small></b-spinner>
                <span v-else>İndir</span>
              </b-button>
            </span>
            <span v-else-if="props.column.field === 'shipmentName'">
              <div>{{ props.row.shipmentName }}</div>
              <small v-if="props.row.clientDisplayName" class="text-muted client-name-info">
                {{ props.row.clientDisplayName }}
              </small>
            </span>
            <span v-else>{{ props.row[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import ShipmentDocumentService from '../../service/ShipmentDocumentService';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'admin-shipment-document-list',
  data() {
    return {
      rows: [],
      columns: [
        { field: 'id', hidden: true },
        { label: 'Ad', field: 'shipmentName', sortable: false },
        { label: 'Düzenleme Tarihi', field: 'issueDate', sortable: false },
        { label: 'İşlemler', field: 'actions', sortable: false }
      ],
      loading: false,
      rows_: [],
      totalRecords: 0,
      currentPage: 1,
      perPage: 20,
      downloadingId: null,
    };
  },
  methods: {
    onPageChange(params) {
      this.loadShipmentDocuments(params.currentPage);
    },
    downloadPdf(row) {
      this.downloadingId = row.id;
      const products = row.products || [];
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 40],
        content: [
          {
            columns: [
              {
                width: '*',
                stack: [
                  { text: row.clientName || '', bold: true, fontSize: 13 },
                  { text: row.address || '', fontSize: 10, margin: [0, 4, 0, 0] }
                ]
              },
              {
                width: 'auto',
                text: row.issueDate || '',
                alignment: 'right',
                fontSize: 11,
                bold: true
              }
            ]
          },
          { text: '\n\n' },
          {
            table: {
              headerRows: 1,
              widths: ['*', 'auto'],
              body: [
                [
                  { text: 'Ürün', bold: true, fillColor: '#eeeeee' },
                  { text: 'Miktar', bold: true, fillColor: '#eeeeee', alignment: 'right' }
                ],
                ...products.map(p => [
                  { text: p.productName || '' },
                  { text: String(p.quantity ?? ''), alignment: 'right' }
                ])
              ]
            }
          }
        ],
        defaultStyle: { fontSize: 10 }
      };
      const fileName = `${row.shipmentName || 'irsaliye'}.pdf`.replace(/[\\/:*?"<>|]/g, '_');
      try {
        pdfMake.createPdf(docDefinition).download(fileName, () => {
          this.downloadingId = null;
        });
      } catch (e) {
        console.error('PDF oluşturulurken hata:', e);
        this.downloadingId = null;
      }
    },
    async loadShipmentDocuments(page) {
      this.loading = true;
      try {
        const response = await ShipmentDocumentService.getShipmentDocuments(page);
        this.rows = response.items || [];
        if (response.meta) {
          this.totalRecords = response.meta.total_count || 0;
          this.perPage = response.meta.per_page || this.perPage;
          this.currentPage = response.meta.current_page || page;
        }
      } catch (error) {
        console.error("İrsaliyeler yüklenirken hata oluştu:", error);
        this.$errorNotification(this, "İrsaliyeler görüntülenirken hata oluştu.");
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.loadShipmentDocuments(1);
  }
};
</script>

<style scoped>
.client-name-info {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-top: 2px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>


